import { Button } from "../ui/Button.jsx";
import { Icon } from "../ui/Icon.jsx";
import { INDUSTRIES } from "./HeroMock.jsx";
import { submitWaitlist } from "../../lib/waitlist.js";

// Injected at build time by build.js (see WAITLIST_API_URL).
const API_URL = process.env.WAITLIST_API_URL;

const EMPTY = { name: "", email: "", company: "", website: "" };

export function Waitlist({ activeIndustry }) {
  const { useState } = React;
  const [values, setValues] = useState(EMPTY);
  const [status, setStatus] = useState("idle"); // idle | submitting | success | error
  const [error, setError] = useState("");

  const submitting = status === "submitting";
  const update = (field) => (e) => setValues((v) => ({ ...v, [field]: e.target.value }));

  const submit = async (e) => {
    e.preventDefault();
    if (submitting) return;
    setStatus("submitting");
    setError("");
    try {
      const industry = activeIndustry === null ? undefined : INDUSTRIES[activeIndustry];
      await submitWaitlist(
        {
          name: values.name.trim(),
          email: values.email.trim(),
          company: values.company.trim(),
          vertical: industry ? industry.key : "",
          website: values.website,
        },
        {
          apiUrl: API_URL,
          context: { page: window.location.origin + window.location.pathname },
        }
      );
      setStatus("success");
      if (typeof window.gtag === "function") {
        window.gtag("event", "generate_lead", { method: "waitlist" });
      }
    } catch (err) {
      console.error("Waitlist submission failed:", err.cause || err);
      setError(err.message);
      setStatus("error");
    }
  };

  return (
    <section className="section" id="waitlist">
      <div className="container">
        <div className="waitlist-card" data-reveal>
          <span className="badge badge-accent">
            <span className="badge-dot"></span>
            <span>Waitlist open</span>
          </span>
          <h2>We're taking a small number of design partners.</h2>
          <p>
            Join the waitlist and we'll reach out to onboard your business as one of our first
            design partners — shaping the product around how your business actually works.
          </p>
          {status === "success" ? (
            <div className="waitlist-success" role="status">
              <span className="ico"><Icon.Check /></span>
              You're on the list. We'll be in touch.
            </div>
          ) : (
            <form className="waitlist-form" onSubmit={submit}>
              <div className="waitlist-row">
                <input
                  type="text"
                  name="name"
                  autoComplete="name"
                  required
                  className="waitlist-input"
                  placeholder="Your name"
                  aria-label="Your name"
                  value={values.name}
                  onChange={update("name")}
                  disabled={submitting}
                />
                <input
                  type="text"
                  name="company"
                  autoComplete="organization"
                  required
                  className="waitlist-input"
                  placeholder="Company"
                  aria-label="Company"
                  value={values.company}
                  onChange={update("company")}
                  disabled={submitting}
                />
              </div>
              <div className="waitlist-row">
                <input
                  type="email"
                  name="email"
                  autoComplete="email"
                  required
                  className="waitlist-input"
                  placeholder="you@company.com"
                  aria-label="Work email"
                  value={values.email}
                  onChange={update("email")}
                  disabled={submitting}
                />
                <Button as="button" type="submit" variant="primary" disabled={submitting}>
                  {submitting ? "Joining…" : "Join the waitlist"}
                </Button>
              </div>
              {/* Honeypot: hidden from people, filled by bots. The API drops entries that fill it.
                  The DOM name is deliberately meaningless so browser and password-manager
                  autofill never populate it; it still posts as the "website" field. */}
              <div className="waitlist-hp" aria-hidden="true">
                <label htmlFor="waitlist-nr-extra">Leave this empty</label>
                <input
                  id="waitlist-nr-extra"
                  type="text"
                  name="nr_extra"
                  tabIndex={-1}
                  autoComplete="off"
                  value={values.website}
                  onChange={update("website")}
                />
              </div>
              <p className="waitlist-consent">We'll only use this to contact you about NgineRoom.</p>
              {status === "error" && (
                <p className="waitlist-error" role="alert">{error}</p>
              )}
            </form>
          )}
          <div className="waitlist-mailto">
            Prefer email? Reach us at <a href="mailto:connect@ngineroom.ai">connect@ngineroom.ai</a>
          </div>
        </div>
      </div>
    </section>
  );
}
